import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 18 22"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#BB2100",
      fillRule: "evenodd",
      d: "M4.5 0A4.5 4.5 0 0 0 0 4.5v13A4.5 4.5 0 0 0 4.5 22h9a4.5 4.5 0 0 0 4.5-4.5V4.862h-4.101a.862.862 0 0 1-.871-.852V0H4.5Zm9 0v3.696c0 .389.322.704.72.704h3.779v-.001L13.5 0ZM4.159 14.256h-.915V10.19h1.699c.992 0 1.592.575 1.592 1.406v.012c0 .94-.749 1.428-1.681 1.428h-.695v1.22Zm0-3.258v1.243h.725c.457 0 .724-.268.724-.616v-.012c0-.4-.285-.615-.742-.615h-.707Zm4.675 3.258H7.212V10.19h1.622c1.306 0 2.21.877 2.21 2.022v.011c0 1.144-.904 2.033-2.21 2.033Zm1.253-2.033c0-.72-.505-1.225-1.253-1.225h-.707v2.45h.707c.748 0 1.253-.493 1.253-1.213v-.012Zm2.685 2.033h-.915V10.19h3.166v.814h-2.251v.865h1.984v.813h-1.984v1.574Z",
      clipRule: "evenodd"
    }
  )
);
var SvgPdfFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var PdfFilled_default = SvgPdfFilled;

export { PdfFilled_default as default };
